<h3-navbar [class.sampling-nav]="enableNewSamplingNav">
  <h3-saving-indicator
    projection-location="breadcrumbs"
    *ngIf="isSaving"
  ></h3-saving-indicator>
  <ng-container projection-location="left">
    <h3-sample-task-review-status
      *ngIf="enableNewSamplingNav"
    ></h3-sample-task-review-status>
  </ng-container>
  <div *ngIf="enableNewSamplingNav" projection-location="right" class="actions">
    <h3-finalize-button></h3-finalize-button>
    <h3-sampling-nav-controls></h3-sampling-nav-controls>
  </div>
</h3-navbar>
